import React, { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { RoundedBox, Text, OrbitControls } from "@react-three/drei";
import "./about.css";

function CreditCard3D() {
  const cardRef = useRef();

  useFrame((state) => {
    if (cardRef.current) {
      cardRef.current.rotation.y = (state.clock.getElapsedTime() * 0.4) % (2 * Math.PI);
      cardRef.current.rotation.x = Math.sin(state.clock.elapsedTime * 0.3) * 0.08;
    }
  });

  return (
    <group ref={cardRef} scale={1.7}>
      <RoundedBox args={[3.2, 2, 0.06]} radius={0.08} smoothness={6}>
        <meshStandardMaterial color="#052daa" metalness={0.7} roughness={0.25} />
      </RoundedBox>

      <mesh position={[-1.1, 0.5, 0.035]}>
        <boxGeometry args={[0.38, 0.28, 0.02]} />
        <meshStandardMaterial color="#FFD700" metalness={1} roughness={0.15} />
      </mesh>

      <Text position={[-1.25, 0.0, 0.051]} fontSize={0.25} color="#FFD700" anchorX="left">
        5183 2094 8745 1234
      </Text>

      <Text position={[-1.25, -0.45, 0.051]} fontSize={0.18} color="#FFD700" anchorX="left">
        FUNDSWALLE
      </Text>

      <Text position={[0.9, -0.45, 0.051]} fontSize={0.16} color="#FFD700" anchorX="left">
        10/30
      </Text>
    </group>
  );
}

function CardCanvas() {
  return (
    <Canvas camera={{ position: [0, 0, 5] }}>
      <ambientLight intensity={0.7} />
      <directionalLight position={[5, 5, 5]} intensity={1.2} />
      <CreditCard3D />
      <OrbitControls enableZoom={false} enablePan={false} enableRotate={true} />
    </Canvas>
  );
}

export default function About() {
  return (
    <div className="about-wrapper">
      <div className="about-container">
        <div className="about-left">

            <h2 className="why-title mb-4">
              Your <span className="highlight">Financial Freedom</span> Starts Here
            </h2>
          <p>
            Fundswalle brings you instant credit, simplified loans, and intelligent finance tools — combining technology and reliability for a truly effortless experience.
          </p>

          <div className="about-points">
            <div>💳 Smart Credit Management</div>
            <div>📱 Seamless Mobile Experience </div>
            <div>🛡️ Bank-Level Security</div>
            <div>🌍 Trusted by Thousands</div>
          </div>

          <p>
            Navigate your financial journey with confidence. From personal goals to business growth, Fundswalle empowers you with the tools and trust you need to succeed.
          </p>

       <div className="cta">
  <a href="about-us" target="_blank" rel="noopener noreferrer">
    <button>Explore More</button>
  </a>
</div>

        </div>

        <div className="about-right">
          <div className="card-box">
            <CardCanvas />
          </div>
        </div>
      </div>
    </div>
  );
}
